// removed by extract-text-webpack-plugin
module.exports = {"Container":"CenterContainer__Container__RAEVQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CenterContainer/CenterContainer.css
// module id = 128
// module chunks = 0